import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Pagination({ page, totalPages, onChange }) {
  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-center gap-2">
      <Button
        variant="outline"
        size="sm"
        disabled={page <= 1}
        onClick={() => onChange((p) => p - 1)}
      >
        <ChevronLeft className="w-4 h-4" />
      </Button>
      <span className="text-sm text-muted-foreground">
        Page{' '}
        <span className="font-mono font-medium">{page}</span>
        {' '}of{' '}
        <span className="font-mono font-medium">{totalPages}</span>
      </span>
      <Button
        variant="outline"
        size="sm"
        disabled={page >= totalPages}
        onClick={() => onChange((p) => p + 1)}
      >
        <ChevronRight className="w-4 h-4" />
      </Button>
    </div>
  );
}